import React from "react";
import { Link } from "react-router-dom";
import { useForm, ValidationError } from "@formspree/react";
import Logo from "../../images/logo.svg";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const Footer = (props) => {
  const [state, handleSubmit] = useForm("xkgnzzwn");

  return (
    <footer className="wpo-site-footer">
      <div className="shape-1">
        <svg width="795" height="12" viewBox="0 0 795 12" fill="none">
          <rect width="795" height="12" fill="url(#paint0_linear_1_223)" />
          <defs>
            <linearGradient
              id="paint0_linear_1_223"
              x1="795"
              y1="5.99883"
              x2="0"
              y2="5.99883"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#274DCF" />
              <stop offset="1" stopColor="white" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="shape-2">
        <svg width="795" height="12" viewBox="0 0 795 12" fill="none">
          <rect width="795" height="12" fill="url(#paint0_linear_1_224)" />
          <defs>
            <linearGradient
              id="paint0_linear_1_224"
              x1="0"
              y1="5.99883"
              x2="795"
              y2="5.99898"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#DE2045" />
              <stop offset="1" stopColor="white" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="wpo-upper-footer">
        <div className="container">
          <div className="row">
            <div className="col col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <img src={Logo} alt="campaign logo" />
                </div>
                <p>
                  Taisha St. Jean Tard is dedicated to bringing transparency,
                  fairness, and equality to our community. Join us in creating a
                  brighter future.
                </p>
                <ul>
                  <li>
                    <a
                      href="https://www.facebook.com/taisha4eriecounty"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="ti-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com/taisha4eriecounty"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="ti-twitter-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/taisha4eriecounty"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="ti-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/taisha-st-jean-tard-bb2836186/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="ti-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Quick Links:</h3>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/home">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/about">
                      About
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/volunteer">
                      Volunteer
                    </Link>
                  </li>
                  <li>
                    <a
                      onClick={ClickHandler}
                      href="https://secure.actblue.com/donate/taishaforeriecounty"
                      target="_blank"
                    >
                      Donate
                    </a>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/donate">
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget wpo-service-link-widget">
                <div className="widget-title">
                  <h3>Contact Us</h3>
                </div>
                <div className="contact-ft">
                  <ul>
                    <li>
                      <i className="fi ti-location-pin"></i>PO Box 13, Buffalo,
                      NY 14201
                    </li>
<li>
                      <i className="fa fa-envelope-o" aria-hidden="true"></i>
                      taisha4eriecounty@gmail.com
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget newsletter-widget">
                <div className="widget-title">
                  <h3>Newsletter:</h3>
                </div>
                <p>
                  Sign up for updates on Taisha’s campaign and upcoming events.
                </p>
                {state.succeeded ? (
                  <p>Thank you for subscribing to our newsletter!</p>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <div className="input-1">
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Enter your email"
                        required
                      />
                      <ValidationError
                        prefix="Email"
                        field="email"
                        errors={state.errors}
                      />
                    </div>
                    <div className="submit clearfix">
                      <button type="submit" disabled={state.submitting}>
                        <i className="fa fa-paper-plane" aria-hidden="true"></i>
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wpo-lower-footer">
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <p className="copyright">
                Copyright &copy; {new Date().getFullYear()} Friends for Taisha
                St. Jean Tard Campaign. All Rights Reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
